import { PropsWithClassName } from 'lib-shared-types-utils';
import { memo, useMemo } from 'react';

import { useChannelDashboardChannelContext } from '../../../../channelDashboardChannel.context';

import { ChannelDashboardAverageResponseTimeMetric } from './components/average/channelAverageResponseTimeMetric';
import { ChannelDashboardSLAResponseTimeMetric } from './components/sla/channelSlaResponseTimeMetric';

type ChannelDashboardResponseTimeMetricProps = PropsWithClassName;

export const ChannelDashboardResponseTimeMetric = memo(
  function ChannelDashboardResponseTimeMetric(
    props: ChannelDashboardResponseTimeMetricProps,
  ): JSX.Element {
    const { slaPolicies } = useChannelDashboardChannelContext();

    const slaPolicy = useMemo(
      () =>
        slaPolicies?.find((policy) =>
          policy.metrics.some(({ metric }) => metric === 'response_time'),
        ),
      [slaPolicies],
    );

    return slaPolicy ? (
      <ChannelDashboardSLAResponseTimeMetric {...props} slaPolicy={slaPolicy} />
    ) : (
      <ChannelDashboardAverageResponseTimeMetric {...props} />
    );
  },
);
